
export default {
  name: 'SearchHeader',

  props: {
    pageName: {
      type: String,
      required: true
    },
    pageDescription: {
      type: String,
      required: true
    }
  }
}
